import { lazy } from 'solid-js'

export default {
    component: lazy(() => import('../../pages/search-page/search-page.jsx')),
    partnerScoped: true,
    path: '/partners/:partnerSlug/search',
    showCurrencyHeader: true,
    showFooter: true,
    showFullWidthHeader: true,
    showHeader: true,
    showHeaderMenu: false,
    showSidebar: false,
    showUserHeader: false,
    title: 'Lodgr | Partner Search',
}
